/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-12-21",
    versionChannel: "nightly",
    buildDate: "2023-12-21T00:16:02.610Z",
    commitHash: "a5560587da4a9816a5c36cd93671f3d62550f004",
};
